import { render, staticRenderFns } from "./GroupTrend.vue?vue&type=template&id=0bef96a7"
import script from "./GroupTrend.vue?vue&type=script&lang=js"
export * from "./GroupTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports